import { Component, Input, Output, EventEmitter, SimpleChanges } from '@angular/core';

@Component({
  selector: 'app-inspection-product-filter',
  templateUrl: './inspection-product-filter.component.html',
  styleUrls: ['./inspection-product-filter.component.scss'],
})
export class InspectionProductFilter {
  @Input() productTypes: any[] = [];
  @Output() productTypesChanged = new EventEmitter<any[]>();

  selectedProductTypes: any[] = [];

  ngOnInit() {
    this.onChange();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['productTypes'] && this.productTypes?.length) {
      this.selectedProductTypes = this.productTypes.filter(p => p.checked == true);
    }
  }

  onChange() {
    this.productTypes.forEach(p => {
      p.checked = this.selectedProductTypes.includes(p);
    });
    this.productTypesChanged.emit(this.selectedProductTypes);
  }
}
